export default __webpack_public_path__ + "static/media/LongTermEffects-reduced.4aff36a6.jpg";